import React from 'react'

// set the defaults
export const LangContext = React.createContext({
    language: "",
    languageName: "",
    setLanguage: () => { }
});